import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pruta-guy-star.svg")